export default "__VITE_ASSET__Bt1Ddt2y__"